/*
  boroj-locale-links.js — language-persistence guard.

  Problem: on a non-primary locale (this store serves English at /en/), several
  custom links are authored as ROOT-relative paths WITHOUT the locale prefix —
  the header mega-menu items (/collections, /pages/about …), the footer
  "Track Order" (/account), the browse-by-original filter links
  (/collections/all?filter…), and the JS-rendered mini-cart / tester-upsell
  product links. Clicking any of them drops the shopper back to the primary
  (Arabic) locale — an unwanted language switch mid-journey.

  Fix: normalize every same-origin, root-relative <a href> so it carries the
  ACTIVE locale prefix, and keep watching for links injected later (mini-cart
  drawer, tester upsell, quick view, browse re-render). Idempotent and a no-op
  on the primary locale. The language/currency selector is a <form> (not <a>),
  so switching languages is never affected.
*/
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return;                 // primary locale — nothing to prefix
  var prefix = root.replace(/\/+$/, '');    // "/en/" -> "/en"

  // Root paths that must NOT be locale-prefixed (Shopify infra / app proxies / assets).
  var SKIP_PREFIXES = ['/cdn/', '/cdn-cgi/', '/apps/', '/tools/', '/services/', '/wpm/', '/.well-known/'];

  function shouldSkip(href) {
    if (!href) return true;
    if (href.charAt(0) !== '/') return true;      // external, #anchor, tel:, mailto:, relative
    if (href.charAt(1) === '/') return true;      // protocol-relative //host
    if (href === prefix || href.indexOf(prefix + '/') === 0) return true; // already localized
    for (var i = 0; i < SKIP_PREFIXES.length; i++) {
      if (href.indexOf(SKIP_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  // Never touch language / currency switchers. Scope this to the localization widget
  // ONLY — NOT every <form> (the cart form wraps the mini-cart's cross-sell product
  // links, which DO need localizing).
  function inSelector(a) {
    return !!(a.closest && a.closest(
      'form[action*="/localization"], .shopify-localization-form, [class*="bls__"], [class*="localization"], [data-disclosure-language], [data-disclosure-country]'
    ));
  }

  function fixLink(a) {
    if (!a || a.nodeType !== 1 || a.tagName !== 'A') return;
    var href = a.getAttribute('href');
    if (shouldSkip(href) || inSelector(a)) return;
    a.setAttribute('href', prefix + (href === '/' ? '/' : href));
  }

  function scan(ctx) {
    var links = (ctx || document).querySelectorAll('a[href^="/"]');
    for (var i = 0; i < links.length; i++) fixLink(links[i]);
  }

  function run() {
    scan(document);
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') { fixLink(m.target); continue; }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'A') fixLink(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    });
    // Re-fixing an already-prefixed href is a no-op (shouldSkip true), so setAttribute
    // from this observer cannot loop.
    mo.observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
